import React from 'react'
import cloudOne from '../../images/large-clouds.svg'
import styles from "./animation.module.css"

export default class CloudOne extends React.Component {

  render(){
    return (
             
                <div className={styles[`animateCloudOne`]}
                     css={{position:`absolute`,
                             top:`30%`,
                             left:`-25%`,
                             width:`100%`,
                             height:`100%`,
                             '@media(min-width:800px)':{
                               top:'27%',
                               left:'-15%'
                             }
                            
                           }}>

                    <img src={cloudOne} 
                         alt="cloud one" 
                         css={{ filter:`drop-shadow(-5px -10px 3px rgba(0,0,0,.05))`,
                                transform:`scale(1.7)`,
                                '@media(min-width:800px)':{
                                  transform:`scale(1)`
                                }

                              }} />
                </div>
            
      )
  }
}
